export let ImagePath;

(function (ImagePath) {
  ImagePath['LANDING'] = 'landing';
  ImagePath['USERS'] = 'users';
  ImagePath['ECOMMERCE'] = 'e-commerce';
  ImagePath['PROFILE'] = 'profile';
  ImagePath['WIDGET'] = 'widget';
})(ImagePath || (ImagePath = {}));

// ==============================|| NEW URL - GET IMAGE URL ||============================== //

export function getImageUrl(name, path) {
  return new URL(`/src/assets/images/${path}/${name}`, import.meta.url).href;
}

// ==============================|| NORMALIZE MEDIA URL ||============================== //
/**
 * Normalizes media URLs to use the correct BASE_URL from environment variables
 * Handles:
 * - Full URLs with localhost (replaces with BASE_URL)
 * - Relative paths (prepends BASE_URL)
 * - Already correct full URLs (returns as-is)
 * 
 * @param {string|null|undefined} url - The media URL to normalize
 * @returns {string|null} - The normalized URL or null if input is falsy
 */
export function normalizeMediaUrl(url) {
  if (!url) return null;
  
  // If it's already a full URL
  if (url.startsWith('http://') || url.startsWith('https://')) {
    // Check if it contains localhost (hardcoded)
    if (url.includes('localhost') || url.includes('127.0.0.1')) {
      // Replace localhost with BASE_URL from env
      const baseURL = import.meta.env.VITE_APP_API_URL || '';
      const cleanBaseUrl = baseURL.endsWith('/') ? baseURL.slice(0, -1) : baseURL;
      
      // Extract the path after the domain
      try {
        const urlObj = new URL(url);
        const path = urlObj.pathname;
        return `${cleanBaseUrl}${path}`;
      } catch (e) {
        // If URL parsing fails, try to extract path manually
        const pathMatch = url.match(/\/media\/.*$/);
        if (pathMatch) {
          return `${cleanBaseUrl}${pathMatch[0]}`;
        }
        return url; // Fallback to original if we can't parse it
      }
    }
    // Already a valid full URL, return as-is
    return url;
  }
  
  // It's a relative path, prepend BASE_URL
  const baseURL = import.meta.env.VITE_APP_API_URL || '';
  const cleanBaseUrl = baseURL.endsWith('/') ? baseURL.slice(0, -1) : baseURL;
  
  // Ensure the path starts with /
  const normalizedPath = url.startsWith('/') ? url : `/${url}`;
  
  return `${cleanBaseUrl}${normalizedPath}`;
}
